import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    paperXs: {
        width: 500
    },
    paperSm: {
        width: 600
    },
    paperMd: {
        width: 900
    },
    paperLg: {
        width: 1000
    },
    paperXl: {
        width: 1200
    },
    title: {
        borderBottom: '1px solid ' + theme.palette.background.primary,
        paddingBottom: theme.spacing(1),
    },
    content: {
        marginTop: theme.spacing(1)
    }
}));


export default function CustomAlert(props) {
    const classes = useStyles();
    const { open, onClose, title, message, customMessage, isConfirm, confirmAction, maxWidth, title_close, showButtonClose, color } = props;
    console.log("showButtonClose CustomAlert==", showButtonClose)
    const { t } = useTranslation();
    return (
        <Dialog
            open={open}
            onClose={showButtonClose ? onClose : null}
            maxWidth={maxWidth ? maxWidth : 'sm'}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{
                paper: maxWidth === 'sm' ? classes.paperSm : classes.paperXs,
            }}
        >
            <DialogTitle id="alert-dialog-title" color={color?color:undefined} className={classes.title}>
                {title}
            </DialogTitle>
            <DialogContent className={classes.content}>
                {customMessage ? customMessage : <DialogContentText id="alert-dialog-description">
                    {message}
                </DialogContentText>}
            </DialogContent>
            <DialogActions>
                {isConfirm ?
                    <Button variant="contained" sx={{ background: color?color:undefined }} onClick={confirmAction.okAction}>
                        {confirmAction.okTitle ? confirmAction.okTitle : t('btn_ok')}
                    </Button>
                    : (showButtonClose && <Button variant="contained" sx={{ background: color?color:undefined }} onClick={onClose}>{title_close ? title_close : t('btn_ok')}</Button>)
                }
                {isConfirm && showButtonClose &&<Button variant="outlined" onClick={confirmAction.cancelAction ? confirmAction.cancelAction : onClose}>
                    {confirmAction.cancelTitle ? confirmAction.cancelTitle : t('btn_cancel')}
                </Button>}
            </DialogActions>
        </Dialog>
    );
}